import {Layout} from 'react-admin';
import {CustomMenu} from "./CustomMenu";
import {FC, PropsWithChildren} from "react";

export const CustomLayout: FC<PropsWithChildren> = ({ children }) => (
  <Layout menu={CustomMenu}>
    {children}
  </Layout>
);
